import React, { useEffect, useState } from "react";
import styles from "../../../pages/Home.module.css";
import Button from "../Dealers/Button";
import { useAuth } from "../../context/Auth";
import { LocakScreen, UnlocakScreen } from "../../icons/Icon2";
import { useInactivity } from "../../context/Inactivity";

const TimerLogout = ({ setShowModal }) => {
  const { showModalTimer } = useInactivity();
  const [timeLeft, setTimeLeft] = useState(420 - showModalTimer);
  const { mode, handleSignOut } = useAuth();


  // console.log("showModalTimer", showModalTimer);
  // console.log("right time", 420 - showModalTimer);
  // console.log("timeLeft", timeLeft);


  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          handleSignOut();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  };

  return (
    <>
      <div
        className={styles.timer}
        style={{
          background: mode ? "#2C2E33" : "#fff",
          color: mode ? "#fff" : "#000",
        }}
      >
        <div className={styles.logoutText1}>
          <p>
            Your Session <span style={{ color: "red" }}> Lock IN </span>
          </p>
        </div>
        <div>
          <img src="/assets/updatedAssets/logout_img.png" alt="" />
        </div>
        <div className={styles.logoutText}>
          <p>
            Time remaining before <span style={{ color: "red" }}> lock: </span>{" "}
          </p>
        </div>
        <div> {formatTime(timeLeft)} </div>
        <div style={{ marginTop: "10px", display: "flex", gap: "20px" }}>
          <div style={{ width: "140px" }}>
            <Button
              buttonBgColor={"#4164E3"}
              buttonText={"Keep Unlock"}
              buttonTextColor={"#ccc"}
              buttonClick={() => setShowModal(false)}
              buttonIcon={<UnlocakScreen />}
            />
          </div>
          <div style={{ width: "140px" }}>
            <Button
              buttonBgColor={"#000"}
              buttonText={"Lock"}
              buttonTextColor={"#ccc"}
              buttonClick={handleSignOut}
              buttonIcon={<LocakScreen />}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default TimerLogout;
